module.exports = __webpack_public_path__ + "img/file-earmark-minus.9b1902ff.svg";